<section *ngIf="announcement" class="platform-announcement" role="status">
  <div class="platform-announcement__icon-shell" aria-hidden="true">
    <span nz-icon nzType="notification" nzTheme="outline" class="platform-announcement__icon"></span>
  </div>
  <p class="platform-announcement__message">{{ message }}</p>
  <div class="platform-announcement__actions">
    <span *ngIf="hasTarget"
      class="platform-announcement__cta-tooltip"
      nz-tooltip
      [nzTooltipTitle]="isSignOrderActionDisabled
        ? ('QR_POSTER_TEMPLATE.SIGN_ORDER_PERMISSION_DENIED' | translate)
        : null"
      [attr.tabindex]="isSignOrderActionDisabled ? 0 : null"
      [attr.aria-label]="isSignOrderActionDisabled
        ? ('QR_POSTER_TEMPLATE.SIGN_ORDER_PERMISSION_DENIED' | translate)
        : null">
      <button nz-button type="button" class="platform-announcement__cta"
        [disabled]="isSignOrderActionDisabled"
        (click)="openTarget()">
        {{ 'PLATFORM_ANNOUNCEMENT.CTA' | translate }}
        <span nz-icon nzType="arrow-right" nzTheme="outline" class="platform-announcement__cta-icon" aria-hidden="true"></span>
      </button>
    </span>
    <button nz-button nzType="text" type="button" class="platform-announcement__dismiss" (click)="dismiss()"
            [attr.aria-label]="'COMMON.CLOSE' | translate">
      <span nz-icon nzType="close" nzTheme="outline" aria-hidden="true"></span>
    </button>
  </div>
</section>
